import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { UserMenu } from "@/components/UserMenu";
import { InstallBanner } from "@/components/InstallApp";
import { AvisoEndereco, enderecoJaVisto } from "@/components/AvisoEndereco";
import { InnovaIAAluna, NovidadeIA } from "@/components/InnovaIAAluna";
import { NovidadeTricolab } from "@/components/NovidadeTricolab";

export default function StudentLayout() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="h-16 sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 px-4 sm:px-6 flex items-center justify-between">
        <Link to="/app"><Brand size="md" variant="membros" /></Link>
        <UserMenu />
      </header>
      <AvisoEndereco />
      <InstallBanner depois={!enderecoJaVisto()} />   {/* um aviso por vez: primeiro o do endereço */}
      {pathname === "/app" && <NovidadeTricolab />}   {/* Tricolab liberado e ainda sem uso */}
      {pathname === "/app" && <NovidadeIA />}   {/* aviso de lançamento da In'Nova IA, só na lista de cursos */}
      <Outlet />
      <InnovaIAAluna key={`${user?.id || ""}-${user?.role || ""}`} />
    </div>
  );
}
